
import moment from 'moment'

export const displayDateFormat = 'MM/DD/YYYY';

export function parseDate(string) {
    if (!string) return ''

    const date = moment(string)

    return date.isValid() ? date.format(displayDateFormat) : ''
}

export function calculateDaysBetween(start, end) {
    start = moment(start, displayDateFormat);
    end = moment(end, displayDateFormat);

    if (!start.isValid() || !end.isValid()) return null;

    const diff = end.diff(start, 'days') + 1;

    return diff >= 0 ? diff : 0;
}

export function addDays(date, days) {
    return moment(date).add(days, 'days');
}

function setSpanishFormatDate() {
    moment.locale('es', {
            months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
            monthsShort: 'Ene._Feb._Mar._Abr._May._Jun._Jul._Ago._Sep._Oct._Nov._Dic.'.split('_'),
            weekdays: 'Domingo_Lunes_Martes_Miercoles_Jueves_Viernes_Sabado'.split('_'),
            weekdaysShort: 'Dom._Lun._Mar._Mier._Jue._Vier._Sab.'.split('_'),
            weekdaysMin: 'Do_Lu_Ma_Mi_Ju_Vi_Sa'.split('_')
        }
    );
}

function setEnglishFormatDate() {
    moment.locale('en');
}

export function setLanguageFormatDate(language) {
    switch (language) {
        case "es":
            setSpanishFormatDate();
            break;
        default:
            setEnglishFormatDate();
    }
}

export function hoursSinceDate (date)  {
    return moment().diff(date, 'hours')
}

export function currentYear () {
    return new Date().getFullYear()
}

const ONE_HOUR_IN_SECONDS = 3600;
const ONE_HOUR = 1;

export const segToHours = (seconds) => {
    const hours = Math.ceil(seconds / ONE_HOUR_IN_SECONDS);
    if (hours < ONE_HOUR) {
        return (seconds / ONE_HOUR_IN_SECONDS).toFixed(1)
    }
    return hours
}

/**
 * Validates a date string against a specified format.
 *
 * @param {Object} options - The options for date validation.
 * @param {string} options.value - The date string to validate.
 * @param {string} [options.format=displayDateFormat] - The format against which to validate the date string.
 * @returns {boolean} True if the date string is valid according to the given format, otherwise false.
 */
export const isValidDate = ({value, format = displayDateFormat}) => {
    if (typeof value !== 'string') {
        return false;
    }
    return moment(value, format, true).isValid();
};
